// latest: zhangmyh 2017-10-26 1:50 PM
// 供应商档案参照
// import operationaa from './opt'
import Collection from 'common/vo/collection'
import 'collection/yinhang'
import { Get } from 'common'
import condition from './condition'
import uMessage from 'components/message'
/* global $ ko u */

let _config
function init (refer) {
  // 每次都重新加载
  if (condition.datatable.getValue('bankname') !== null || condition.datatable.getValue('province') !== null || condition.datatable.getValue('city') !== null) {
    condition.datatable.setValue('bankname', null)
    condition.datatable.setValue('city', null)
    condition.datatable.setValue('province', null)
    // collection.datatable.clear()
  }
  let collection = Collection.create('collection.yinhang')
  let enterpriseId = refer.enterpriseId || window.global.user.enterpriseId
  let selectedData = []
  let selectflag = false
  collection.on('data', function (result) {
    if (_config.multiSelect && !_config.repeatable && refer.options.defaultData) {
      // 初始化默认值
      if (selectedData.length <= 0) {
        let defaultData = refer.options.defaultData()
        if (defaultData instanceof Array) {
          selectedData = defaultData
        }
      }

      let SelectIndex = []
      result.data.result.forEach(function (listItem, i) {
        selectedData.forEach(function (item) {
          if (item.id === listItem.id) {
            SelectIndex.push(i)
          }
        })
      })
      collection.datatable.setRowsSelect(SelectIndex)
    }
    selectflag = true
  })
  collection.load({
    purid: enterpriseId,
    bankname: '',
    province: '',
    city: '',
    searchKey: '',
    pageSize: 10,
    pageIndex: 0
  })
  const search = () => {
    console.log(condition.datatable.getValue('bankname'))
    console.log(condition.datatable.getValue('province'))
    console.log(condition.datatable.getValue('bankname'))
    if (condition.datatable.getValue('bankname') !== null && condition.datatable.getValue('province') !== null && condition.datatable.getValue('city') !== null) {
      collection.load({
        purid: enterpriseId,
        bankname: condition.datatable.getValue('bankname'),
        province: condition.datatable.getValue('province'),
        city: condition.datatable.getValue('city'),
        searchKey: vm.searchKey(),
        pageSize: 10,
        pageIndex: 0
      })
    } else {
      // alert("请输入银行，省，市")
      uMessage('warning', '请选择银行，省，市!')
      collection.load({
        purid: enterpriseId,
        bankname: '',
        province: '',
        city: '',
        searchKey: '',
        pageSize: 10,
        pageIndex: 0
      })
      // collection.datatable.setValue('grid', '')
      // console.log(22222222)
      // console.log(collection.datatable.getValue('grid'))
    }
    // console.log(collection.datatable)
    // if (condition.datatable.getValue('bankname') != null && condition.datatable.getValue('province') != null && condition.datatable.getValue('city') != null) {
    //   vm.editpage(true)
    // } else {
    //   vm.editpage(false)
    // }
  }
  let vm = {
    search,
    searchKey: ko.observable(''),
    zhishu: ko.observable(),
    model: condition.datatable,
    editpage: ko.observable(false),
    bankname: ko.observableArray([{
      name: '中国银行',
      value: '中国银行'
    },
    {
      name: '中国农业银行',
      value: '中国农业银行'
    },
    {
      name: '中国工商银行',
      value: '中国工商银行'
    },
    {
      name: '中国建设银行',
      value: '中国建设银行'
    },
    {
      name: '交通银行',
      value: '交通银行'
    },
    {
      name: '中国邮政储蓄银行',
      value: '中国邮政储蓄银行'
    },
    {
      name: '中国光大银行',
      value: '中国光大银行'
    },
    {
      name: '华夏银行',
      value: '华夏银行'
    },
    {
      name: '中国民生银行',
      value: '中国民生银行'
    },
    {
      name: '平安银行',
      value: '平安银行'
    },
    {
      name: '招商银行',
      value: '招商银行'
    },
    {
      name: '兴业银行',
      value: '兴业银行'
    },
    {
      name: '上海浦东发展银行',
      value: '上海浦东发展银行'
    },
    {
      name: '渤海银行',
      value: '渤海银行'
    },
    {
      name: '广东发展银行',
      value: '广东发展银行'
    },
    {
      name: '其他银行',
      value: '其他银行'
    }
    ]),
    province: ko.observableArray([
      {
        name: '北京市',
        value: '北京市'
      },
      {
        name: '天津市',
        value: '天津市'
      },
      {
        name: '河北省',
        value: '河北省'
      },
      {
        name: '内蒙古',
        value: '内蒙古'
      },
      {
        name: '山西省',
        value: '山西省'
      },
      {
        name: '辽宁省',
        value: '辽宁省'
      },
      {
        name: '吉林省',
        value: '吉林省'
      },
      {
        name: '黑龙江省',
        value: '黑龙江省'
      },
      {
        name: '上海市',
        value: '上海市'
      },
      {
        name: '江苏省',
        value: '江苏省'
      },
      {
        name: '浙江省',
        value: '浙江省'
      },
      {
        name: '安徽省',
        value: '安徽省'
      },
      {
        name: '福建省',
        value: '福建省'
      },
      {
        name: '江西省',
        value: '江西省'
      },
      {
        name: '山东省',
        value: '山东省'
      },
      {
        name: '河南省',
        value: '河南省'
      },
      {
        name: '湖北省',
        value: '湖北省'
      },
      {
        name: '湖南省',
        value: '湖南省'
      },
      {
        name: '广东省',
        value: '广东省'
      },
      {
        name: '广西',
        value: '广西'
      },
      {
        name: '海南省',
        value: '海南省'
      },
      {
        name: '四川省',
        value: '四川省'
      },
      {
        name: '重庆市',
        value: '重庆市'
      },
      {
        name: '贵州省',
        value: '贵州省'
      },
      {
        name: '云南省',
        value: '云南省'
      },
      {
        name: '西藏',
        value: '西藏'
      },
      {
        name: '陕西省',
        value: '陕西省'
      },
      {
        name: '甘肃省',
        value: '甘肃省'
      },
      {
        name: '青海省',
        value: '青海省'
      },
      {
        name: '宁夏',
        value: '宁夏'
      },
      {
        name: '新疆',
        value: '新疆'
      }
    ]),
    city: ko.observableArray([]),
    reset: function () {
      condition.datatable.setValue('bankname', null)
      condition.datatable.setValue('city', null)
      condition.datatable.setValue('province', null)
      vm.searchKey('')
      vm.city([])
    },
    gridconfig: {
      id: 'banknamedoc',
      data: collection,
      type: 'grid',
      multiSelect: false,
      editable: false,
      sortable: false,
      canDrag: false,
      canSwap: false,
      noScroll: true,
      pagination: true,
      fields: [{
        field: 'linkNum',
        dataType: 'String',
        title: '银行联行号',
        width: '50%'
      }, {
        field: 'bankName',
        dataType: 'String',
        title: '基本开户行',
        width: '50%'
      }]
    }
  }
  condition.datatable.on('province.valuechange', function () {
    if (condition.datatable.getValue('province') !== null) {
      condition.datatable.setValue('city', null)
      vm.city([])
      Get('/cpu-supplymgr/Silver/SilverLinkByCity', { province: condition.datatable.getValue('province')
      }).then(function (data, state) {
        if (data.data != null) {
          for (var obj of data.data.result) {
            vm.city.push({
              value: obj.city,
              name: obj.city
            })
          }
        } else {
          vm.city([])
        }
      })
    }
  })
  let app = u.createApp()
  app.init(vm, $('#bankname')[0])
  // 提交事件
  refer.registerSubmitFunc(() => {
    return selectedData
  })
  collection.datatable.on('unSelect', function (obj) {
    // vm.editpage(false)
    vm.city([])
    let selectData = collection.datatable.getRowByRowId(obj.rowIds[0])
    let index = -1
    selectedData.forEach(function (item, i) {
      if (item.id === selectData.getValue('id')) {
        index = i
      }
    })
    if (index >= 0) {
      selectedData.splice(index, 1)
    }
    // collection.datatable.clear()
  })
  // vm.bankname([])
  // vm.province([])
  // vm.city([])
  // 选择每一行用的操作
  collection.datatable.on('select', function (obj) {
    // console.log(condition.datatable.getValue('bankname'))
    // console.log(condition.datatable.getValue('province'))
    // console.log(collection.datatable)
    // vm.editpage(false)
    if (!_config.multiSelect) {
      let selectData = collection.datatable.getCurrentRow().data
      selectedData = {
        linkNum: selectData.linkNum.value,
        bankName: selectData.bankName.value,
      }
      refer.submit()
      vm.city([])
      // collection.datatable.clear()
      return
    }
    // 默认初始化已选择数据的时候不触发数据改变
    if (selectflag) {
      let selectData = collection.datatable.getRowByRowId(obj.rowIds[obj.rowIds.length - 1])
      selectedData.push({
        linkNum: selectData.linkNum.value,
        bankName: selectData.bankName.value,
      })
      // collection.datatable.clear()
    }
  })
  // $('#bankname').on('keypress', 'input', function (e) {
  //   if (e.keyCode == 13) {
  //     // 设置延时以让ko绑定输入框值
  //     setTimeout(search, 1)
  //   }
  // })
}

let template = require('./index.html')
export default function (config) {
  _config = Object.assign({
    multiSelect: true,
    repeatable: true
  }, config)

  return {
    init,
    template
  }
}
// await Get('/cpu-supplymgr/templateAllot/searchTemplateByMaterialClass',
//   { templateType: pageMgr.state,
//     isCertification: 0,
//     id: viewModel.model.getRow(0).getValue('materialClassId'),
//   }).then(function (data, status) { ajax请求



// WEBPACK FOOTER //
// ./src/components/modalrefer/yinhang/index.js